import { render } from "./MobileTransactionCard.vue?vue&type=template&id=64806d2e&scoped=true&ts=true"
import script from "./MobileTransactionCard.vue?vue&type=script&lang=ts"
export * from "./MobileTransactionCard.vue?vue&type=script&lang=ts"

import "./MobileTransactionCard.vue?vue&type=style&index=0&id=64806d2e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64806d2e"]])

export default __exports__